//  ---------------------------------------------------------------------------
//  DO NOT EDIT THIS FILE! This File was auto-generated.
//  ---------------------------------------------------------------------------
define('root/Assets/Js/Templates',[
], function () {
	return arguments;
});

